import UploadImageFormFields from './UploadImageFormFields';

export default UploadImageFormFields;
